import { useState, useEffect } from "react";
import { GetNotifications } from "../actions/adminQueries";
import axios from "../services/api/api";
import { useQueryClient } from "@tanstack/react-query";

export default function useIntrusiveNotifications({ enabled = true } = {}) {
  const notifications = GetNotifications({ enabled });
  const queryClient = useQueryClient();
  const [showIntrusiveModal, setShowIntrusiveModal] = useState(false);
  const [intrusiveNotifications, setIntrusiveNotifications] = useState([]);

  useEffect(() => {
    if (
      notifications.isPending ||
      !notifications.data ||
      notifications.data.length === 0
    )
      return;

    const unreadIntrusive = notifications.data.filter(
      (noti) =>
        noti.notice.isIntrusive &&
        !noti.isSeenByMe &&
        !noti.notice.isDeleted
    );

    if (unreadIntrusive.length > 0) {
      setIntrusiveNotifications(unreadIntrusive);
      setShowIntrusiveModal(true);

      const idsToMarkAsRead = unreadIntrusive.map((noti) => noti.notice.id);
      axios
        .post("/User/SetNoticesToRead", { ids: idsToMarkAsRead })
        .then(() => {
          queryClient.invalidateQueries({ queryKey: ["FetchNotifications"] });
        });
    }
  }, [notifications.isPending, notifications.data, queryClient]);

  const handleCloseIntrusiveModal = () => {
    setShowIntrusiveModal(false);
  };

  const handleDismissIntrusiveModal = () => {
    setShowIntrusiveModal(false);
  };

  return {
    showIntrusiveModal,
    intrusiveNotifications,
    handleCloseIntrusiveModal,
    handleDismissIntrusiveModal,
  };
}
